@let user = user$ | async;
@let authState = authState$ | async;
@let canUseApp = permissionService.canLogistUseBetaOutkeep$ | async;
@let isDesktop = deviceService.isDesktop$ | async;

<tui-root
  [ngClass]="{
    'x-root-desktop': isDesktop,
  }"
>
  @if (
    authState === 'authenticated' &&
    user &&
    user.personId &&
    canUseApp &&
    (isDesktop || !$isWorkflowRoute()) &&
    !$isRestrictedRequestRoute()
  ) {
    <x-main-layout>
      <router-outlet></router-outlet>
    </x-main-layout>
  } @else {
    <router-outlet></router-outlet>
  }
</tui-root>
